import {
    type ModelFilterActionsType,
    INIT_MODEL_FILTER,
    SET_FILTERED_GRADES,
    SET_MODEL_FILTER_DATA,
    SET_MODEL_FILTER_VALUE,
} from "../actions/ModelFilterActions";
import type {
    FilterInfoType,
    ModelFilterDimensionType,
    ModelFilterGradeType,
} from "../../../../../common-deprecated/types/CommonTypes";

export type ModelFilterStateType = FilterInfoType & {
    name: string;
    internalCode: string;
    filterValues: { [index: string]: string };
    filteredGrades: ModelFilterGradeType[];
    dimensions: {
        capacity: ModelFilterDimensionType[];
        dimensions: ModelFilterDimensionType[];
        bootImage: {
            default: string;
            set: string;
        };
    };
    lastSelectedFilterCode: string;
};

export const initialState: ModelFilterStateType = {
    name: "",
    internalCode: "",
    cars: [],
    filters: [],
    filterValues: {},
    filteredGrades: [],
    dimensions: {
        capacity: [],
        dimensions: [],
        bootImage: {
            default: "",
            set: "",
        },
    },
    lastSelectedFilterCode: "",
};

const modelFilter = (
    state: ModelFilterStateType = initialState,
    action: ModelFilterActionsType,
): ModelFilterStateType => {
    switch (action.type) {
        case SET_MODEL_FILTER_VALUE: {
            const { filterValues, filterCode } = action;

            // Make sure empty filterValues stay in the filterValues object.
            const newFilterValues = Object.keys(state.filterValues).reduce(
                (filterVals: { [index: string]: string }, code) => {
                    if (filterValues) filterVals[code] = filterValues[code] || "";
                    return filterVals;
                },
                {},
            );

            // If the initial filter configuration doesn't set a filter value,
            // ensure it is still set
            if (!newFilterValues[filterCode] && filterValues?.[filterCode]) {
                newFilterValues[filterCode] = filterValues?.[filterCode];
            }

            return {
                ...state,
                filterValues: newFilterValues,
                lastSelectedFilterCode: action.filterCode,
            };
        }

        case INIT_MODEL_FILTER: {
            const { filterValues = {} } = action;

            return { ...state, filterValues };
        }

        case SET_FILTERED_GRADES: {
            const { filteredGrades, dimensions } = action;
            return { ...state, filteredGrades, dimensions: dimensions || initialState.dimensions };
        }

        case SET_MODEL_FILTER_DATA: {
            const { name, internalCode, cars, filters } = action;
            return { ...state, name, internalCode, cars, filters };
        }

        default:
            return state;
    }
};

export default modelFilter;
